export interface NavItem {
    label: string
    href: string
}

export const NAV_ITEMS: NavItem[] = [
    { label: 'Film', href: '#film' },
    { label: 'Monoblock', href: '#monoblock' },
    { label: 'Finishes', href: '#finishes' },
    { label: 'Atelier', href: '#atelier' }
]

export const COMMISSION_HREF = '#commission'
